/* ACS 2026-10-11 photo auto-trim (owner picked option 5 "Auto-trim white space").
   Each product photo shows whole (contain) in its white frame. This script looks at a small (<= 96 px)
   copy of the photo, finds the box around everything that is not near-white (r, g and b > 236) and not
   transparent (alpha < 16), and zooms the photo so that box fills the frame with a 6 % margin on every
   side (zoom 1.02 to 2.2, and never past 2.5 x the photo's own pixels). The box is centred and always stays
   whole inside the frame; the rest of the photo is clipped to its own box. Only a class and CSS variables
   are set (transform + clip-path in assets/acs-photo-trim.css), so the page layout never moves, and the
   script never reads the layout: frame sizes come from a ResizeObserver, the small copy is decoded off the
   main thread (createImageBitmap). Photos that cannot be read (another site without CORS) or have no white
   space are left as they are.
   Spots: product cards (collections in Tiles / Compact / List, search, related products, comics grid),
   comics feature cards, home "Shop by category", "Help me find it" tiles, search suggestions and
   product page thumbnails. Results are kept per picture for the visit (sessionStorage acs_trim_v2).
   Loaded WITHOUT defer at the top of <body> (layout/theme.liquid), so it watches every photo as the page is
   parsed: a photo measured earlier in the visit (another page, the in-stock swap, Back) is zoomed before it is
   first drawn. A photo seen for the first time shows whole until its small copy has been read (usually a few
   frames after it loads). */
(function () {
  'use strict';
  var w = window, d = document;
  if (w.AcsPhotoTrim || !d.querySelectorAll || !w.Map || !w.Set || !w.WeakSet || !w.ResizeObserver) return;

  var SEL = '.product-card-wrapper .card__media img,.acs-ccard__media img,.acs-shortcut__media img,' +
    '.acs-tile__media img,img.predictive-search__image,.product .thumbnail img';
  var N = 96, WHITE = 236, CLEAR = 16, MARGIN = 0.06, ZMIN = 1.02, ZMAX = 2.2, UPSCALE = 2.5;
  var STORE = 'acs_trim_v2', KEEP = 1500, PARALLEL = 4;
  var stats = { measured: 0, zoomed: 0, ms: 0 };

  /* ---- results per picture: [x0, y0, x1, y1 (fractions), width / height, file width measured] ---- */
  var cache = new Map(), unreadable = new Set(), saveTimer = 0;
  try {
    var saved = JSON.parse(w.sessionStorage.getItem(STORE) || 'null');
    if (saved && typeof saved === 'object') {
      Object.keys(saved).forEach(function (k) { if (Array.isArray(saved[k])) cache.set(k, saved[k]); });
    }
  } catch (e) { /* storage blocked: work without it */ }
  function save() {
    if (saveTimer) return;
    saveTimer = setTimeout(function () {
      saveTimer = 0;
      try {
        var o = {}, keys = Array.from(cache.keys()), i = Math.max(0, keys.length - KEEP);
        for (; i < keys.length; i++) o[keys[i]] = cache.get(keys[i]);
        w.sessionStorage.setItem(STORE, JSON.stringify(o));
      } catch (e) { /* full or blocked */ }
    }, 1500);
  }
  function keyOf(img) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src || src.indexOf('data:') === 0) return '';
    try {
      var u = new URL(src, location.href), v = u.searchParams.get('v');
      return u.pathname + (v ? '?v=' + v : '');
    } catch (e) { return ''; }
  }
  function round4(n) { return Math.round(n * 10000) / 10000; }

  /* ---- find the product inside the photo ---- */
  var canvas = null, ctx = null;
  function scanPixels(source, cw, ch, nw, nh) {
    if (!canvas) {
      canvas = d.createElement('canvas');
      ctx = canvas.getContext('2d', { willReadFrequently: true });
    }
    if (!ctx) return false;
    var data;
    try {
      canvas.width = cw;
      canvas.height = ch;
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(source, 0, 0, cw, ch);
      data = ctx.getImageData(0, 0, cw, ch).data;
    } catch (e) {
      return false; /* tainted canvas (photo from another site) or a broken file */
    }
    var x0 = cw, y0 = ch, x1 = -1, y1 = -1, x, y, i;
    for (y = 0; y < ch; y++) {
      for (x = 0; x < cw; x++) {
        i = (y * cw + x) * 4;
        if (data[i + 3] < CLEAR) continue;
        if (data[i] > WHITE && data[i + 1] > WHITE && data[i + 2] > WHITE) continue;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
      }
    }
    if (x1 < 0) return [0]; /* nothing but white: leave it */
    /* one more pixel all round: another file size or decoder can see a faint edge one pixel further out */
    x0 = Math.max(0, x0 - 1); y0 = Math.max(0, y0 - 1); x1 = Math.min(cw - 1, x1 + 1); y1 = Math.min(ch - 1, y1 + 1);
    return [round4(x0 / cw), round4(y0 / ch), round4((x1 + 1) / cw), round4((y1 + 1) / ch), round4(nw / nh), nw];
  }
  /* Keep the box that holds every file size measured (sizes can differ by a pixel at the edges). */
  function remember(k, box, nw) {
    var old = cache.get(k);
    if (old && old.length > 5) {
      box = box.length > 5
        ? [Math.min(old[0], box[0]), Math.min(old[1], box[1]), Math.max(old[2], box[2]), Math.max(old[3], box[3]), box[4], nw]
        : old.slice(0, 5).concat(nw);
    }
    cache.set(k, box);
    save();
  }

  var running = 0, waiting = [], pending = new Map(); /* key -> photos waiting for that measurement */
  function needsMeasure(img, k) {
    if (!k || unreadable.has(k) || !(img.complete && img.naturalWidth)) return false;
    var box = cache.get(k);
    return !box || (box.length > 5 && box[5] !== img.naturalWidth);
  }
  function measure(img) {
    var k = keyOf(img);
    if (!needsMeasure(img, k)) return;
    if (pending.has(k)) { if (pending.get(k).indexOf(img) < 0) pending.get(k).push(img); return; }
    pending.set(k, [img]);
    waiting.push([img, k]);
    pump();
  }
  function pump() {
    while (running < PARALLEL && waiting.length) start(waiting.shift());
  }
  function now() { return w.performance ? w.performance.now() : 0; }
  var idle = w.requestIdleCallback ? function (fn) { w.requestIdleCallback(fn, { timeout: 500 }); }
    : function (fn) { setTimeout(fn, 30); };
  function start(job) {
    var img = job[0], k = job[1], nw = img.naturalWidth, nh = img.naturalHeight;
    var cw = Math.max(8, Math.round(N * Math.min(1, nw / nh))), ch = Math.max(8, Math.round(N * Math.min(1, nh / nw)));
    running++;
    function done(box) {
      running--;
      var list = pending.get(k) || [];
      pending.delete(k);
      if (box === false) { if (!cache.has(k)) unreadable.add(k); }
      else if (box) { stats.measured++; remember(k, box, nw); }
      for (var i = 0; i < list.length; i++) update(list[i]);
      pump();
    }
    function sync() {
      /* no off-thread decoding in this browser: read the photo itself when the browser is idle */
      idle(function () {
        var t0 = now(), box = img.naturalWidth === nw ? scanPixels(img, cw, ch, nw, nh) : null; /* null: file changed, try again */
        stats.ms += now() - t0;
        done(box);
      });
    }
    var p = null;
    try {
      if (w.createImageBitmap) p = w.createImageBitmap(img, { resizeWidth: cw, resizeHeight: ch, resizeQuality: 'high' });
    } catch (e) { p = null; }
    if (!p) { sync(); return; }
    p.then(function (bm) {
      var t0 = now(), box = scanPixels(bm, cw, ch, nw, nh);
      if (bm.close) bm.close();
      stats.ms += now() - t0;
      done(box);
    }, sync);
  }

  /* ---- zoom that fits the product box in the frame (no layout reads: sizes come from the ResizeObserver) ---- */
  function pct(n) { return Math.max(0, Math.min(100, n)); }
  function geom(img, box) {
    var s = img.__acsTrimSize, W = s ? s[0] : 0, H = s ? s[1] : 0;
    if (W < 12 || H < 12) return undefined; /* not laid out yet, or hidden (List view secondary photo) */
    if (!box || box.length < 5) return null;
    var a = box[4], rw, rh;
    if (W / H > a) { rh = H; rw = H * a; } else { rw = W; rh = W / a; }
    var ox = (W - rw) / 2, oy = (H - rh) / 2;
    var x0 = ox + box[0] * rw, x1 = ox + box[2] * rw, y0 = oy + box[1] * rh, y1 = oy + box[3] * rh;
    var bw = x1 - x0, bh = y1 - y0;
    if (bw <= 0 || bh <= 0) return null;
    var z = Math.min(W * (1 - 2 * MARGIN) / bw, H * (1 - 2 * MARGIN) / bh, ZMAX);
    var src = Math.max(img.naturalWidth || 0, parseInt(img.getAttribute('width'), 10) || 0, box[5] || 0);
    if (src > 0) z = Math.min(z, UPSCALE * src / rw);
    if (!(z >= ZMIN)) return null;
    var tx = 100 * z * (W / 2 - (x0 + x1) / 2) / W, ty = 100 * z * (H / 2 - (y0 + y1) / 2) / H;
    var base = 50 * (1 - 1 / z);
    return {
      s: z, x: tx, y: ty, w: rw * z,
      t: pct(base - ty / z), r: pct(base + tx / z), b: pct(base + ty / z), l: pct(base - tx / z)
    };
  }

  var settling = [], settleOn = false;
  function apply(img, g) {
    var st = img.style, on = img.classList.contains('acs-trim');
    if (!g) {
      if (on) {
        img.classList.remove('acs-trim');
        ['--acs-trim-s', '--acs-trim-x', '--acs-trim-y', '--acs-trim-clip'].forEach(function (p) { st.removeProperty(p); });
      }
      return;
    }
    st.setProperty('--acs-trim-s', g.s.toFixed(4));
    st.setProperty('--acs-trim-x', g.x.toFixed(3) + '%');
    st.setProperty('--acs-trim-y', g.y.toFixed(3) + '%');
    st.setProperty('--acs-trim-clip', 'inset(' + g.t.toFixed(3) + '% ' + g.r.toFixed(3) + '% ' + g.b.toFixed(3) + '% ' + g.l.toFixed(3) + '%)');
    if (!on) {
      img.classList.add('acs-trim-now'); /* no animation for the first zoom */
      img.classList.add('acs-trim');
      settling.push(img);
      if (!settleOn) {
        settleOn = true;
        w.requestAnimationFrame(function () {
          w.requestAnimationFrame(function () {
            settleOn = false;
            var l = settling.splice(0);
            for (var i = 0; i < l.length; i++) l[i].classList.remove('acs-trim-now');
          });
        });
      }
    }
    sharpen(img, g);
  }
  /* A zoomed photo shows more pixels than the theme's srcset "sizes" planned for. A larger file is asked for only
     when the one shown is clearly too small: under 2/3 of the pixels the zoom needs, counting at most 2 screen pixels
     per CSS pixel. The file's own width comes from its srcset entry: naturalWidth is in CSS pixels for a srcset photo
     (the slot width), which made every phone photo look half as sharp as it is and fetched a third of them twice.
     When the zoom is known before the browser has picked a file (a photo measured earlier in the visit), "sizes" is
     set first, so that file is downloaded once. The browser only trades up; the original file is the largest. */
  var SHARP = 0.67, DPR_MAX = 2;
  function files(img) { /* srcset entries: [[absolute URL, width in pixels], ...] */
    var out = [];
    (img.srcset || '').split(',').forEach(function (c) {
      var m = /^\s*(\S+)\s+(\d+)w\s*$/.exec(c);
      if (m) { try { out.push([new URL(m[1], location.href).href, +m[2]]); } catch (e) { /* bad entry */ } }
    });
    return out;
  }
  function filePx(img, list) { /* pixel width of the file the photo shows now */
    var cur = img.currentSrc, i;
    for (i = 0; cur && i < list.length; i++) if (list[i][0] === cur) return list[i][1];
    try { var q = parseInt(new URL(cur).searchParams.get('width'), 10); if (q > 0) return q; } catch (e) { /* no URL */ }
    return img.naturalWidth;
  }
  function plannedPx(img, list) { /* the file the theme's own "sizes" gives this photo box */
    var s = img.__acsTrimSize, want = (s ? s[0] : 0) * (w.devicePixelRatio || 1), best = 0, max = 0, i, v;
    for (i = 0; i < list.length; i++) {
      v = list[i][1];
      if (v > max) max = v;
      if (v >= want && (!best || v < best)) best = v;
    }
    return best || max;
  }
  function sharpen(img, g) {
    if (!img.srcset) return;
    var dpr = w.devicePixelRatio || 1, need = g.w * Math.min(dpr, DPR_MAX), px = Math.ceil(need / dpr);
    var was = parseInt(img.getAttribute('data-acs-trim-sizes'), 10) || 0;
    if (px <= was) return;
    var list = files(img);
    if (img.naturalWidth) {
      var have = filePx(img, list), most = 0;
      for (var i = 0; i < list.length; i++) if (list[i][1] > most) most = list[i][1];
      if (have >= need * SHARP || have >= most) return; /* sharp enough, or already the largest file */
    }
    else if (img.currentSrc || plannedPx(img, list) >= need * SHARP) return; /* already loading, or its file will do */
    img.setAttribute('data-acs-trim-sizes', String(px));
    img.setAttribute('sizes', px + 'px');
  }

  /* Put the right zoom on one photo from what is known now; measure it when that is still missing. */
  function update(img) {
    if (!img.isConnected) return;
    var k = keyOf(img), box = k ? cache.get(k) : null;
    if (!box) {
      if (img.__acsTrimKey && img.__acsTrimKey !== k) { img.__acsTrimKey = ''; apply(img, null); } /* another picture here */
    } else {
      var g = geom(img, box);
      if (g !== undefined) {
        if (g && !img.classList.contains('acs-trim')) stats.zoomed++;
        img.__acsTrimKey = k;
        apply(img, g);
      }
    }
    if (img.__acsTrimNear) measure(img);
  }

  /* ---- watching the photos ---- */
  var ro = new ResizeObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i], img = e.target, bs = e.contentBoxSize, W, H;
      if (bs && bs[0]) { W = bs[0].inlineSize; H = bs[0].blockSize; } else { W = e.contentRect.width; H = e.contentRect.height; }
      var old = img.__acsTrimSize;
      if (old && Math.abs(old[0] - W) < 0.5 && Math.abs(old[1] - H) < 0.5) continue;
      img.__acsTrimSize = [W, H];
      update(img); /* runs after layout and before paint: a known photo is zoomed before it is first drawn */
    }
  });
  var io = w.IntersectionObserver ? new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e.isIntersecting) continue;
      io.unobserve(e.target);
      e.target.__acsTrimNear = true;
      update(e.target);
    }
  }, { rootMargin: '400px 0px' }) : null;
  function onLoad(e) {
    var img = e.target;
    if (img.__acsTrimNear) update(img); /* else the IntersectionObserver takes it once it is near the screen */
  }

  var known = new WeakSet();
  function register(img) {
    if (known.has(img) || !img.isConnected) return;
    known.add(img);
    img.addEventListener('load', onLoad);
    ro.observe(img);
    if (io) io.observe(img); else img.__acsTrimNear = true;
  }
  function forget(img) {
    if (!known.has(img)) return;
    known.delete(img);
    img.__acsTrimNear = false;
    img.__acsTrimSize = null;
    ro.unobserve(img);
    if (io) io.unobserve(img);
  }
  function each(node, fn) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches(SEL)) { fn(node); return; }
    if (node.querySelectorAll) {
      var l = node.querySelectorAll(SEL);
      for (var i = 0; i < l.length; i++) fn(l[i]);
    }
  }

  /* Photos added later: in-stock grid swap, filters, paging, search suggestions, the finder, theme editor. */
  each(d.documentElement, register);
  if (w.MutationObserver) {
    new MutationObserver(function (records) {
      var i, j, n;
      for (i = 0; i < records.length; i++) {
        n = records[i].removedNodes;
        for (j = 0; j < n.length; j++) if (n[j].nodeType === 1 && !n[j].isConnected) each(n[j], forget);
      }
      for (i = 0; i < records.length; i++) {
        n = records[i].addedNodes;
        for (j = 0; j < n.length; j++) if (n[j].nodeType === 1 && n[j].isConnected) each(n[j], register);
      }
    }).observe(d.documentElement, { childList: true, subtree: true });
  }

  w.AcsPhotoTrim = {
    version: '2026-10-11b',
    selector: SEL,
    stats: stats,
    box: function (img) { var k = keyOf(img); return k ? cache.get(k) || null : null; }
  };
})();